export default "__VITE_ASSET__8ff4db42__"